import { basicEnum } from "./base";

export const ResellerCategoryEnum = basicEnum([
    {
        label: "Hotel / Losmen / Homestay",
        value: "hotel",
    },
    {
        label: "Warnet / Gamenet",
        value: "netcafe",
    },
    {
        label: "Cafe / Wisata / Publik Area Lain",
        value: "cafe",
    },
    {
        label: "Pertokoan / Usaha Mikro",
        value: "shops",
    },
    {
        label: "Lainnya",
        value: "other",
    },
]);

export namespace ResellerCategoryEnum {
    export type Labels = (typeof ResellerCategoryEnum)["labels"][number];
    export type Values = (typeof ResellerCategoryEnum)["values"][number];
}
